import { useTranslation } from "react-i18next"

import { Spinner } from "@/components/ui/spinner"

/**
 * Stands in for a Mermaid diagram until its SVG exists: while the lazy
 * MermaidBlock chunk loads, while a streamed diagram is incomplete, and while
 * it renders. One element at one fixed height for all of these, so the answer
 * does not jump between them (#3485).
 */
export function MermaidPlaceholder() {
  const { t } = useTranslation()
  return (
    <section
      aria-busy="true"
      className="not-prose bg-muted/30 text-muted-foreground my-3 flex h-32 items-center justify-center gap-2 rounded-xl border text-sm"
      data-testid="mermaid-placeholder"
    >
      <Spinner className="size-4" />
      <span>{t("answer.rendering")}</span>
    </section>
  )
}
